import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle
} from '@mui/material'
import { useTranslation } from 'react-i18next'

export interface ImagePreviewDialogProps extends Omit<
  DialogProps,
  'children' | 'onClose' | 'open' | 'maxWidth'
> {
  open: boolean
  imageUrl?: string | null
  onClose: () => void
  title?: string
  maxWidth?: DialogProps['maxWidth']
}

export default function ImagePreviewDialog({
  open,
  imageUrl,
  onClose,
  title,
  maxWidth = 'lg',
  ...props
}: ImagePreviewDialogProps) {
  const [t] = useTranslation('common')

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={maxWidth} {...props}>
      <DialogTitle>{title ?? t('previewPhoto')}</DialogTitle>
      <DialogContent>
        {imageUrl && (
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <img
              src={imageUrl}
              style={{
                maxWidth: '100%',
                maxHeight: '80vh',
                width: 'auto',
                height: 'auto',
                borderRadius: '8px'
              }}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('close')}</Button>
      </DialogActions>
    </Dialog>
  )
}
